$(document).ready(function(){
    function imagePOPup(){
        $('.block__social-media-image-popup-image-list').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            fade: true,
            prevArrow: $(".block__social-media-image-arrow-left"),
            nextArrow: $(".block__social-media-image-arrow-right")
        });
    }
    
    $(document).on("click",".block__social-video-image-list",function(){
        $("body").addClass("overflow-hidden");
        $(".block__social-media-image-popups").css("display","flex");
        var data_id = $(this).attr("data_id");
        if($('.block__social-media-image-popup-image-list').hasClass("slick-initialized")){
            $('.block__social-media-image-popup-image-list').slick('unslick');
        }
        imagePOPup();
        var data_index = $(".block__social-media-image-popup-image#block_"+data_id).attr("data-slick-index");
        $('.block__social-media-image-popup-image-list').slick('slickGoTo', data_index);
    });
    $(document).on("click",".block__social-media-image-popup-close",function(){
        $("body").removeClass("overflow-hidden");
        $(".block__social-media-image-popups").css("display","none");
    });

    $(document).on('click', 'body', function(e){
        var target = e.target;
        if($(".block__social-media-image-popups").is(e.target)){
            $("body").removeClass("overflow-hidden");
            $(".block__social-media-image-popups").css("display","none");
        }
    });
});